export const columns = [
  {
    Header: "Role",
    accessor: "roleName",
    className: "center",
  },
  {
    Header: "Username",
    accessor: "userName",
    className: 'center',
  },
];
